import { cn } from "src/lib/utils";

function Skeleton({ className, ...props }) {
  return (
    <div
      className={cn(
        "animate-pulse rounded-md bg-gray-400 dark:bg-muted",
        className
      )}
      {...props}
    />
  );
}

// Skeleton component for OrderRow that matches the exact design


export { Skeleton };
